import {
  type DetailedHTMLProps,
  type HTMLAttributes,
  type ReactElement,
  useCallback,
  useEffect,
  useRef,
} from "react";
import type { Options } from "../types";
import { autoTextSize } from "../utils/autoSize";

export const Fluid = ({
  minFontSizePx,
  maxFontSizePx,
  fontSizePrecisionPx,
  children,
}: Options &
  DetailedHTMLProps<
    HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >): ReactElement => {
  const updateTextSizeRef = useRef<ReturnType<typeof autoTextSize>>();

  useEffect(() => updateTextSizeRef.current?.(), [children]);

  const refCallback = useCallback(
    (innerEl: HTMLElement | null) => {
      updateTextSizeRef.current?.disconnect();

      const containerEl = innerEl?.parentElement;
      if (!innerEl || !containerEl) return;

      updateTextSizeRef.current = autoTextSize({
        innerEl,
        containerEl,
        minFontSizePx,
        maxFontSizePx,
        fontSizePrecisionPx,
      });
    },
    [minFontSizePx, maxFontSizePx, fontSizePrecisionPx],
  );

  return <div ref={refCallback}>{children}</div>;
};
